











































import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import Component from "vue-class-component";
import AdminDialog from "@/components/AdminDialog.vue";
import FurnitureEditCard from "@/components/FurnitureEditCard.vue";
import { Furniture } from "@/data/Furniture";
import { updateItem } from "@/network/inventory-service";

@Component({
  components: { AdminDialog, FurnitureEditCard },
  computed: mapGetters("inventory", {
    inventory: "getInventory",
    getItem: "getItem",
  }),
  methods: mapActions("inventory", ["bindInventory"]),
})
export default class Admin extends Vue {
  inventory!: Furniture[];

  getItem!: (id: string) => Furniture;

  bindInventory!: () => Promise<void>;

  dialog = false;

  showEditCard = false;

  showStoreCmp = true;

  /**
   * Computed property for an item in the inventory.
   */
  get sample(): Furniture {
    return this.inventory[2];
  }

  /**
   * Computed property that gets the same item as `sample` but using a Vuex
   * store getter.
   */
  get compare(): Furniture {
    return this.getItem(this.sample.id);
  }

  /**
   * Called when component is mounted (lifecycle hook); binds inventory to
   * Firestore.
   */
  mounted(): void {
    this.bindInventory();
  }

  /**
   * Updates sample using the inventory service.
   */
  updateSample(): void {
    updateItem(this.sample.id, {
      attributes: {
        ...this.sample.attributes,
        bedbugFree: !this.sample.attributes.bedbugFree,
      },
    }).then(() => {
      console.log(`Successfully updated ${this.sample.id}`);
    });
  }
}
